<template>
<div class="modal" :class="{'is-active': showModal}">
  <div class="modal-background" @click.stop="showModal = false"></div>
  <div class="modal-content" style="max-width: 700px;">
    <div class="box modal-container">
      <div class="modal-content-root">
        <p class="title-font is-size-4 mainColor--text mb-6">Select Keyword Research type</p>
      
        <div class="mb-6">
          <div class="mainColor--text mb-1">Use the Strategy Tool to build keyword clusters for your content plan.</div>
          <div class="mainColor--text">Use the Insight Tool to quickly analyze up to 100 keywords and spot high-value opportunities.</div>
        </div>

        <div class="d-flex gap10 mb-6">

          <div :class="['option', {'active': selectedResearchType === 'keyword-strategy'}]" @click="selectedResearchType = 'keyword-strategy'">
            <i class="material-icons-outlined option-icon">troubleshoot</i>
            <div class="option-title">Keyword Strategy</div>
            <div class="option-desc">The Strategy Tool builds keyword clusters, helping you identify top-level and supporting keywords to shape your content strategy.</div>
          </div>
          
          <div :class="['option', {'active': selectedResearchType === 'keyword-insight'}]" @click="selectedResearchType = 'keyword-insight'">
            <img class="option-icon" src="/static/icon_keyword_insight.svg" width="31" height="29" />
            <div class="option-title">Keyword Insight</div>
            <div class="option-desc">The Insight Tool analyzes up to 100 keywords at once, using POP metrics to quickly reveal key SEO data and hidden gems.</div>
          </div>

        </div>

        <div class="d-flex gap10 mb-5">
          <div style="flex: 1;">
            <div class="mb5 mainColor--text">
              Location
            </div>
            <v-autocomplete outlined dense hide-details="auto"
              :items="availableLocations"
              item-text="location_name"
              item-value="location_code"
              v-model="selectedLocation"
              placeholder="Select location"
              color="grayColor">
            </v-autocomplete>
          </div>
          <div style="flex: 1;">
            <div class="mb5 mainColor--text">
              Language
            </div>
            <v-autocomplete outlined dense hide-details
              :items="targetLanguages"
              v-model="selectedLanguage"
              item-text="language_name"
              item-value="language_code"
              placeholder="Select language"
              color="grayColor">
            </v-autocomplete>
          </div>
        </div>

        <div class="d-flex justify-end gap10 mt-5">
          <v-btn rounded color="profileAnchorColor" class="button-with-icon whiteColor--text text-none"
            :disabled="!canProceed"
            @click.stop="handleContinue">
            <span>Continue</span> <i class="material-icons-outlined" style="font-size: 1rem; margin-top: 2px;">arrow_forward</i>
          </v-btn>
        </div>
      </div>
    </div>
    <button
      class="custom-modal-close-btn"
      aria-label="close"
      @click="() => (showModal = false)">
      <i class="material-icons">close</i>
    </button>
  </div>
</div>
</template>


<script>
import languages from '@/consts/dataforseo_languages.json';
import dataForSeoLocations from '@/consts/dataforseo_locations.json';
import { getHostName } from "@/utils";

export default {
  props: ['modalTitle', 'currentCampaign'],
  data () {
    return {
      showModal: false,

      targetUrl: '',
      campaignName: '',
      selectedLocation: '',
      selectedLanguage: '',

      selectedResearchType: 'keyword-strategy',  // or keyword-insight
    }
  },
  computed: {
    availableLocations () {
      return dataForSeoLocations.locations;
    },
    targetLanguages () {
      return languages;
    },
    site () {
      return this.$store.getters.siteById(parseInt(this.$route.params.siteId))
    },
    canProceed () {
      return this.selectedLocation && this.selectedLanguage
    }
  },
  methods: {
    showModalAction() {
      this.showModal = true;
    },
    handleRedirect (campaign_id) {
      let path = `/sites/${ this.site.id }/campaign/${ campaign_id }`
      if (this.selectedResearchType === 'keyword-strategy') {
        path = `/sites/${ this.site.id }/campaign/${ campaign_id }/keyword-strategy`
      } else if (this.selectedResearchType === 'keyword-insight') {
        path = `/sites/${ this.site.id }/campaign/${ campaign_id }/keyword-insight`
      }
      const query = {
        initLocation: this.selectedLocation,
        initLanguage: this.selectedLanguage,
      }
      this.$router.push({
        path,
        query
      })
    },
    handleContinue () {
      if (this.currentCampaign?.id) {
        this.handleRedirect(this.currentCampaign?.id)
      } else {
        let data = {
          campaignName: this.campaignName,
          siteId: this.site.id,
          targetUrl: this.targetUrl,
          isDomainLevelCampaign: true,
          locationCode: this.selectedLocation,
          languageCode: this.selectedLanguage
        }
        this.$store.commit('showLoading');
        this.$store.dispatch('createKeywordResearchCampaign', data).then(response => {
          if (response.data && response.data.status == 'SUCCESS') {
            let campaign = response.data.campaign;
            this.showModal = false;
            this.handleRedirect(campaign.id)
          }
        })
        .finally(() => {
          this.$store.commit('hideLoading');
        })
      }
    },
  },
  mounted () {
    if (this.site) {
      this.targetUrl = getHostName(this.site.baseURL)
    }

    if (this.currentCampaign?.id) {
      this.selectedLanguage = this.currentCampaign.languageCode
      this.selectedLocation = this.currentCampaign.locationCode ? Number(this.currentCampaign.locationCode) : '';
    }
  }
}
</script>


<style lang="scss" scoped>
.option {
  flex:1; padding: 20px 30px; border-radius: 4px; border: 1px solid var(--v-gray15Color-base); text-align: center;
  margin: 2px;

  cursor: pointer;

  &.active {
    border: 3px solid var(--v-profileAnchorColor-base);
    margin: 0px;
  }

  .option-icon {
    color: var(--v-profileAnchorColor-base); font-size: 2.2rem;
    margin-bottom: 16px;
  }
  
  .option-title {
    color: var(--v-mainColor-base); font-size: 1.1rem;
    margin-bottom: 16px;
  }

  .option-desc {
    color: var(--v-mainColor-base);
  }
}

</style>